export default __webpack_public_path__ + "static/media/dog.39f22ccbb4a1b8450cc1825b32381c28.png";